import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import useGetAllCategory from '../hooks/useGetAllCategory'
import arrow_right from '../images/svgs/arrow-right-icon-black.svg'

export default function BrowseCategories({ title, description }) {
    const categories = useGetAllCategory()
    return (
        <Container fluid className="bg-black pb-5">
            <Container>
                <div className="d-flex align-items-center pt-5 mb-4 gap-5">
                    <h2 className="text-uppercase text-white">
                        {title ? title : 'Browse Categories'}
                    </h2>
                    <p
                        className="text-white m-0 w-md-50"
                        style={{ fontSize: 14 }}
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                </div>

                {/* FEATURED CATEGORIES */}
                <Row className="mb-4">
                    {categories.map(({ node }) => {
                        const { id, name, slug, thumbnailField } = node
                        return (
                            <Col xs={6} lg={3} key={`homepage-browse-categories-${id}`} className="mb-4 h-100">
                                <div className="h-100 overflow-hidden" style={{ borderRadius: 16 }}>
                                    <Link to={`/${slug}`} className='text-black'>
                                        {thumbnailField && <GatsbyImage image={getImage(thumbnailField)} alt='' />}
                                        <p className="bg-white text-center text-uppercase fw-bold ff-primary flex-center gap-2 mb-0 p-3">
                                            {name}
                                            <img src={arrow_right} alt='' />
                                        </p>
                                    </Link>
                                </div>
                            </Col>
                        )
                    })}
                    <Col xs={6} lg={3} className="mb-4">
                        <div className="h-100 overflow-hidden" style={{ borderRadius: 16 }}>
                            <Link to={`/collections`} className='text-black'>
                                <StaticImage src='../images/homepage/collections-category.png' alt='' />
                                <p className="bg-white text-center text-uppercase fw-bold ff-primary flex-center gap-2 mb-0 p-3">
                                    Collections
                                    <img src={arrow_right} alt='' />
                                </p>
                            </Link>
                        </div>
                    </Col>
                </Row>

                {/* <div className="text-center">
                    <Link to='/sale' className="d-inline-block ff-primary text-white text-uppercase border border-white border-2 px-5 py-2" style={{ fontSize: 18 }}>
                        VIEW ALL SALE PRODUCTS
                    </Link>
                </div> */}
            </Container>
        </Container>
    )
}